import React from 'react';

const App = () => (
  <div className='App container-fluid py-5'>
    <h1>404</h1>
    <p>Diese Seite wurde entfernt.</p>
  </div>
);

export default App;
